import util from '@utils/util';
export default {
  name: 'RoomList',
  props: {
    mediaAuto: {
      type: Boolean,
      default: true
    },
    embedVideo: {
      type: Boolean,
      default: true
    },
    shouldCommitPlaylist: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {},
  methods: {
    turnHttps: function turnHttps(url) {
      if (url) {
        return util.forceHttps(url);
      } else {
        return '';
      }
    },
    toggleVolume: function toggleVolume(e) {
      var elem = e.currentTarget;
      var willBeMuted = !this.$refs.player[0].getMuted();
      elem.classList.toggle('ismuted', willBeMuted);
      this.$refs.player[0].setMuted(willBeMuted);
    },
    onSkipLiveRoom: function onSkipLiveRoom(index) {
      // 大数据进入直播间上报
      // 存储当前点击直播间大数据c值和可能正在播放的C
      util.setCookie('lastLdcC', util.getCookie('ldcC'));
      util.setCookie('lastLdcD', util.getCookie('ldcD'));
      util.setCookie('lastVid', util.getCookie('ldcVid'));
      util.setCookie('ldcC', this.list[index].c);
      util.setCookie('ldcD', this.list[index].d);
      util.setCookie('ldcVid', this.list[index].vid);
      if (window.localStorage) {
        window.localStorage.setItem('lastLdcC', window.localStorage.getItem('ldcC'));
        window.localStorage.setItem('lastLdcD', window.localStorage.getItem('ldcD'));
        window.localStorage.setItem('lastVid', window.localStorage.getItem('ldcVid'));
        window.localStorage.setItem('ldcC', this.list[index].c);
        window.localStorage.setItem('ldcD', this.list[index].d);
        window.localStorage.setItem('ldcVid', this.list[index].vid);
      }
      console.log('-点击-大数据进入直播间上报', {
        act: 2,
        c: this.list[index].c,
        d: this.list[index].d
      });
      util.ldcTrack({
        act: 2,
        c: this.list[index].c,
        d: this.list[index].d
      });
      this.$emit('emitOnSkipLiveRoom', this.list[index].vid);
    }
  }
};